/**
 * The artwork slots a garment template may carry: one per logo placement (backend
 * config app.logo_placements, 2026-11-04). `frontArtwork` = chest left (the classic
 * front print), `backArtwork` = the back print; the others draw only on a template whose
 * model.json has a slot of that name (none of the three garments does yet — the bag /
 * pants / chest-centre anchors come with the next model builds).
 *
 * Shared by the resolver (apps/webshop buildThreeDProps → props.logos) and the renderer
 * (HoodieMesh → one <ArtworkSlot> per template slot in this list), so both agree on
 * what an "artwork slot" is.
 */
export const ARTWORK_SLOTS = ['frontArtwork', 'backArtwork', 'chestCenterArtwork', 'bagArtwork', 'pocketArtwork'];

/** The alias props the preview always took, keyed by the slot they stand for. */
export const ARTWORK_ALIASES = {
  frontArtwork: { image: 'frontImage', inverted: 'frontImageInverted' },
  backArtwork: { image: 'backImage', inverted: 'backImageInverted' },
};

export const isArtworkSlot = (name) => ARTWORK_SLOTS.includes(name);
